import React from 'react';
import PropTypes from 'prop-types';
import {caseIOText, messageText, recordStatus} from '../../lib/hydro-records';
import styles from './records.css';

const RecordDetail = ({result}) => {
    const points = result.rubricPoints || [];
    const missed = points.filter(item => !item.passed || item.score < item.maxScore);
    const cases = result.rdoc?.testCases || [];
    const messages = [...(result.rdoc?.compilerTexts || []), ...(result.rdoc?.judgeTexts || [])];
    return (
        <div className={styles.detail}>
            <div className={styles.summary}>
                <div>
                    <strong>{recordStatus(result.status)}</strong>
                    <div className={styles.muted}>
                        {points.length ? `共 ${points.length} 个评分项 · ${missed.length} 项未拿满分` :
                            `通过 ${result.passed || 0} / ${result.total || cases.length} 个测试点`}
                    </div>
                </div>
                <strong className={styles.score}>{`${result.score ?? 0} 分`}</strong>
            </div>
            {result.detailError && <p role="status">{result.detailError}</p>}
            {points.length > 0 && (
                <div>
                    <p className={styles.hint}>
                        {missed.length ? '红色项是还没拿到的分数，下面列出了评分要求和评测原因。' : '所有评分项均已拿满分！'}
                    </p>
                    {points.map((item, index) => (
                        <section
                            className={`${styles.point} ${
                                item.passed && item.score >= item.maxScore ? styles.pass : styles.fail}`}
                            key={index}
                        >
                            <div className={styles.pointHeader}>
                                <strong>{`评分项 ${item.index || index + 1}`}</strong>
                                <strong>{`${item.passed ? '通过' : '未通过'} · ${item.score}/${item.maxScore} 分`}</strong>
                            </div>
                            <p>{item.description || '此旧记录未保存评分要求'}</p>
                            <div className={styles.evidence}>{`评测依据：${item.evidence || '此旧记录未保存详细原因'}`}</div>
                            {item.score < item.maxScore && <div className={styles.missing}>
                                {`还差 ${Number((item.maxScore - item.score).toFixed(2))} 分`}
                            </div>}
                        </section>
                    ))}
                </div>
            )}
            {cases.length > 0 && (
                <div>
                    <p className={styles.hint}>
                        {'预期输出是题目设置的标准答案；实际输出是你的作品本次运行的结果。'}
                    </p>
                    {cases.map((item, index) => (
                        <section
                            className={styles.testCase}
                            key={`${item.subtaskId}-${item.id}-${index}`}
                        >
                            <div className={styles.caseHeader}>
                                <strong>{`测试点 #${item.id ?? index + 1} · ${recordStatus(item.status)}`}</strong>
                                <span>{`${item.time ?? 0} ms · ${item.memory ?? 0} KiB`}</span>
                            </div>
                            <div className={styles.ioGrid}>
                                {['input', 'expected', 'actual'].map((field, fieldIndex) => (
                                    <div
                                        className={styles.ioColumn}
                                        key={field}
                                    >
                                        <strong>{['测试输入', '预期输出', '实际输出'][fieldIndex]}</strong>
                                        <pre>{caseIOText(item, field, result.caseIOAllowed)}</pre>
                                        {item.io?.truncated?.includes(field) && <small>{'内容较长，仅显示前 4096 个字符'}</small>}
                                    </div>
                                ))}
                            </div>
                            {item.io?.source === 'current-testdata' && <p className={styles.hint}>
                                {'旧记录：输入和预期输出来自当前题目数据；实际输出不会用标准答案代替。'}
                            </p>}
                            {messageText(item.message) && <pre className={styles.message}>
                                {messageText(item.message)}
                            </pre>}
                        </section>
                    ))}
                </div>
            )}
            {!points.length && !cases.length && <p className={styles.hint}>
                {result.done === false ? '正在评测，请稍后刷新查看结果。' : '本次评测没有可展示的测试点。'}
            </p>}
            {messages.map((message, index) => (<pre
                className={styles.message}
                key={index}
            >{messageText(message)}</pre>))}
        </div>
    );
};

RecordDetail.propTypes = {result: PropTypes.object.isRequired};
export default RecordDetail;
